export default __webpack_public_path__ + "static/media/consumerTrace-hover.d21187e3.svg";